import type { IconType } from "~/components/ui/icons/icon";
import { Icon } from "~/components/ui/icons/icon";

interface InfoFieldProps {
  label: string;
  icon?: IconType;
  children: React.ReactNode;
}

export function InfoField({ label, icon, children }: InfoFieldProps) {
  return (
    <div>
      <p className="text-xs text-muted-foreground mb-1.5 flex items-center gap-1">
        {icon && <Icon i={icon} className="size-3.5" />}
        {label}
      </p>
      {children}
    </div>
  );
}
